import { createReducer, on } from '@ngrx/store';
import { SetGamesView } from '../actions/gameView.actions';

export const configFeatureKey = 'SetGamesView';

export interface State {
  isGridView: boolean;
}

export const initialState: State = {
  isGridView: false,
};

export const reducer = createReducer(
  initialState,
  on(SetGamesView['[SetGamesView]SetGamesView'], (state, action) => {
    return {
      ...state,
      isGridView: action.data,
    };
  })
);
